import { Button, Icon, setNotification } from '@startlibs/components'
import React, { useState } from 'react'
import {Header} from '../../components/Header'
import {Card, PageContainer} from '../../components/PageLayout'
import {PurviewFooter} from '../../components/PurviewFooter'
import { Errors, TextInput, WithForm } from '@startlibs/form';
import { buildValidation, required } from '../../utils/validation';
import { CASE_CLOSED } from '../../enums/CaseState'
import { jwtPostFetcher } from '../../utils/authFetch';
import { getJwt } from '../../hooks/useJwt';
import { lazyProviderInfo } from '../../components/WithProvider';
import { AssignmentStatusBox } from './expertReview/ExpertReviewList';
import { useIntl } from 'react-intl';

const preValidation = buildValidation({
  'caseInfo.ehrInfo.mrn': [
    (v) => !v?.length && required(),
    (v) => v?.length > 255 && 'Medical Record Number must be 255 characters or less.',
  ],
  'caseInfo.ehrInfo.orderNumber': (v) => v?.length > 255 && 'Order Number must be 255 characters or less.',
})


export const ReconciliationStep = ({caseRequest, setCaseRequest}) => {

  const providerInfo = lazyProviderInfo.read()
  const [isLoading, setLoading] = useState(false)
  const intl = useIntl()

  const readOnly = [CASE_CLOSED].indexOf(caseRequest.state) >= 0
  const caseCompletedWithoutReport = caseRequest.state === CASE_CLOSED && !caseRequest.report?.customReport && !caseRequest.report?.useCustomReport && !caseRequest.report

  const action = ({caseInfo}) =>  jwtPostFetcher(getJwt())("/api/caseInfo?requestId=" + caseRequest.requestId, caseInfo, {method: "PUT"})

  return <>
    <PageContainer>
      <Header title="Case reconciliation"></Header>
      {readOnly && 
        <AssignmentStatusBox reviewed={caseRequest.state === CASE_CLOSED}>
          <div className="waitingBoxContent">
            <Icon icon={caseRequest.state === CASE_CLOSED ? 'check' : 'clock'}/>
            <h4>
              {caseRequest.state === CASE_CLOSED ? 'This case is already completed.' : 'Pending review'}
            </h4>
            <p>{ caseCompletedWithoutReport 
                ? 'The case has been marked as completed, but no report was generated.'
                : intl.formatMessage({
                    defaultMessage:"The report is already concluded and available for the patient contact.",
                    description:"Report concluded warning available to contact label"
                  }) 
            }</p>
          </div>
        </AssignmentStatusBox>
      }
      <Card>
        <h4>Insert the information below to export this case to your EHR system</h4>
        <br></br>
        <WithForm
          alwaysSave
          values={caseRequest}
          preValidation={preValidation}
          action={action}
          onSuccess={(values) => {
            setNotification("All changes saved")
            setCaseRequest(values)
          }}
        >{form => 
          <>
            
              <TextInput
                label="Medical Record Number"
                helpText="(Patient Identification Number)"
                path="caseInfo.ehrInfo.mrn"
                disabled={readOnly}
                mandatory
                maxLength={255}
              />
              <TextInput
                label="Order Number"
                path="caseInfo.ehrInfo.orderNumber"
                disabled={readOnly}
                maxLength={255}
              />
            
            <p>If the order number is empty, the case report will be seen as unsolicited message on the EHR system.</p>  
            <Errors/>
            <div css="text-align: right; margin-top: .5rem;">
              {/* <Button onClick={() => form.confirm('discard-remote-log').then(cancel)}>Cancel</Button> */}
              {!readOnly && <Button type='submit' highlight isLoading={form.isLoading} onClick={() => form.clearErrors()}>Save</Button>}
            </div>
          </>
        }</WithForm>
      </Card>

      {(caseRequest.state === CASE_CLOSED && providerInfo?.ehrHl7Enabled === true) 
        ? <Card style={{display: "flex", justifyContent: "space-between", flexWrap: "nowrap", flexDirection: "row", alignItems: "center"}}>
          <h3 css="margin-bottom:0;font-size:17px;">
            <Icon icon="checked-report" css="font-size:30px;margin-right:0.75rem;vertical-align:-6px;"/>
            Case report is available
          </h3>
          <Button highlight isLoading={isLoading} 
            disabled={caseRequest.caseInfo.ehrInfo.mrn === null || caseRequest.caseInfo.ehrInfo.mrn.length === 0}
            onClick={() => {
              setLoading(true)
              return jwtPostFetcher(getJwt())("/api/admin/sendToEhr?requestId=" + caseRequest.requestId, {}, {method: "POST"})
                .then((_response) => {
                  setLoading(false)
                  setNotification("Case report was sent to EHR")
                })
                .catch((err) => {
                  setLoading(false)
                  console.log(err)
                  setNotification({type: "alert", msg: (_close) => <>Error sending to EHR</>})
                })
              }
            }
          >Send to EHR</Button>
        </Card>
        : null
      }
    </PageContainer>
    <PurviewFooter/>
  </>
}
